import { FC, useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { AuthSessionContext } from '@app/context/AuthContext'
import { useSessionTimeout } from '@app/context/SessionTimeoutContext'

import { useModal } from '@context/ModalsContext'

import { Tourtip } from '@ui/components/Tourtip/Tourtip'

import { ConfirmModal } from '@shared/modals/Confirm.modal'

import { usePreventManualScroll } from './usePreventManualScroll'
import { useTourHost } from './useTourHost'

export const TourHost: FC = () => {
  const { t } = useTranslation()
  const { activeTour, handleClose, handleCommand, handleComplete } = useTourHost()
  const [auth] = useContext(AuthSessionContext)
  const sessionTimeoutContext = useSessionTimeout()

  const warningModal = sessionTimeoutContext?.warningModal

  const cancelConfirmModal = useModal(ConfirmModal, {
    title: t('Cancel Walkthrough Tour?'),
    description: t(
      'Are you sure you want to cancel the walkthrough tour? It takes less than a minute to explore the key features of this page.'
    ),
    primaryLabel: t('Continue Tour'),
    secondaryLabel: t('Cancel Tour'),
    onSecondary: handleClose,
  })

  usePreventManualScroll({
    enabled: !!activeTour,
    allowScrollInSelector: '[class*="tip"]',
  })

  if (!activeTour) {
    return null
  }

  return (
    !warningModal &&
    auth && (
      <Tourtip
        def={activeTour}
        onClose={() => cancelConfirmModal.open()}
        onComplete={handleComplete}
        onCommand={handleCommand}
      />
    )
  )
}
